export const MinusIcon = ({ height = 20, width = 20 }) => {
  return (
    <svg fill="none" height={height} viewBox="0 0 20 20" width={width} xmlns="http://www.w3.org/2000/svg">
      <path d="M4.16669 10H15.8334" stroke="#667085" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.67" />
    </svg>
  );
};
